var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(345 273)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(164 72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(147)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m115 55.221c0-30.497-24.625-55.221-55-55.221s-55 24.724-55 55.221c0 8.1258 1.7628 15.833 4.9005 22.779h100.2c3.1378-6.9455 4.9005-14.653 4.9005-22.779",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 78h3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116 78h3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 78h107",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66 68c0 1.6571-13.209 3-29.5 3-16.293 0-29.5-1.3429-29.5-3s13.207-3 29.5-3c16.291 0 29.5 1.3429 29.5 3",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 42l-0.0074759-37.335c0-2.5759-2.1082-4.6648-4.7098-4.6648h-63.575c-2.5997 0-4.7079 2.0889-4.7079 4.6648l0.0074759 37.335h72.993z",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4549 42l42.545-42h-47.274c-2.6095 0-4.7256 2.0889-4.7256 4.6648l0.0075039 37.335h9.4474z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 42v9.3333c0 2.5778-2.1084 4.6667-4.7121 4.6667h-63.579c-2.6 0-4.7084-2.0889-4.7084-4.6667v-9.3333h73z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 42v9.3333c0 2.5778-2.1084 4.6667-4.7121 4.6667h-63.579c-2.6 0-4.7084-2.0889-4.7084-4.6667v-9.3333h73z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 49.5c0 1.381-1.1171 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.379 1.119-2.5 2.5-2.5 1.3829 0 2.5 1.121 2.5 2.5",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 49.5c0 1.381-1.1171 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.379 1.119-2.5 2.5-2.5 1.3829 0 2.5 1.121 2.5 2.5z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 66 24 66 25.2 57 46.8 57",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48 66 24 66 25.2 57 46.8 57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 66h38",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 42l-0.0074759-37.335c0-2.5759-2.1082-4.6648-4.7098-4.6648h-63.575c-2.5997 0-4.7079 2.0889-4.7079 4.6648l0.0074759 37.335h72.993z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.462 51h-51.924c-1.946 0-3.5382-1.6064-3.5382-3.5698v-35.43h59v35.43c0 1.9634-1.5922 3.5698-3.5382 3.5698",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.462 51h-51.924c-1.946 0-3.5382-1.6064-3.5382-3.5698v-35.43h59v35.43c0 1.9634-1.5922 3.5698-3.5382 3.5698z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 12h-59v-8.5217c0-1.913 1.5922-3.4783 3.5382-3.4783h51.924c1.946 0 3.5382 1.5652 3.5382 3.4783v8.5217z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 12h-59v-8.5217c0-1.913 1.5922-3.4783 3.5382-3.4783h51.924c1.946 0 3.5382 1.5652 3.5382 3.4783v8.5217z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 6c0 1.1043-0.89565 2-2 2s-2-0.89565-2-2 0.89565-2 2-2 2 0.89565 2 2z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.80145 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64783 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.551 33h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.80145 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64783 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64928 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.80145 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64783 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.551 45h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-5.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.80145 0 1.4493 0.64928 1.4493 1.4493v5.1014c0 0.8-0.64783 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.551 20h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-1.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v1.1014c0 0.8-0.64928 1.4493-1.4493 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.551 20h-5.1014c-0.8 0-1.4493-0.64928-1.4493-1.4493v-1.1014c0-0.8 0.64928-1.4493 1.4493-1.4493h5.1014c0.8 0 1.4493 0.64928 1.4493 1.4493v1.1014c0 0.8-0.64928 1.4493-1.4493 1.4493z",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.508 20h-32.016c-0.82353 0-1.4919-0.64928-1.4919-1.4493v-1.1014c0-0.8 0.66837-1.4493 1.4919-1.4493h32.016c0.82502 0 1.4919 0.64928 1.4919 1.4493v1.1014c0 0.8-0.66688 1.4493-1.4919 1.4493",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.508 20h-32.016c-0.82353 0-1.4919-0.64928-1.4919-1.4493v-1.1014c0-0.8 0.66837-1.4493 1.4919-1.4493h32.016c0.82502 0 1.4919 0.64928 1.4919 1.4493v1.1014c0 0.8-0.66688 1.4493-1.4919 1.4493z",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 25h8",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 29h8",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 33h8",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 37h8",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 41h8",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 45h5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.9479 5.9558v-5.9558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.8422e-14 2.9781h5.8974"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2h4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2h4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2h4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 0.12944c-0.22765-0.17259-0.54285-0.17259-0.76874 0-1.9998 1.511-4.4181 2.5712-7.0658 2.9463-0.3152 0.044027-0.54985 0.31699-0.54985 0.63751v5.6267c0 5.2146 3.1713 9.7247 7.7575 11.613 0.1541 0.063399 0.32921 0.063399 0.48506 0 4.5827-1.8879 7.7575-6.3962 7.7575-11.613v-5.6284c0-0.32052-0.23465-0.59172-0.5516-0.63575-2.6459-0.37511-5.0625-1.4353-7.064-2.9463z",
    stroke: "#7450C8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101 93)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#EBA601",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)",
    fill: "#EBA601",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.039 1.476c-0.43314-0.90497-1.3531-1.4754-2.3563-1.461-1.0032 0.014363-1.9064 0.61087-2.3135 1.5279h-2.2834c-0.8521 0-1.5429 0.69076-1.5429 1.5429v2.0571c0 0.28403 0.23025 0.51429 0.51429 0.51429 0.28403 0 0.51429-0.23025 0.51429-0.51429v-2.0571c0-0.28403 0.23025-0.51429 0.51429-0.51429h1.4297c-0.25601 0.28164-0.39887 0.64797-0.40114 1.0286 0 0.8521 0.69076 1.5429 1.5429 1.5429h3.7697c0.92508 0.0066646 1.7179-0.65989 1.8702-1.5724 0.15229-0.91248-0.38106-1.8004-1.2582-2.0945zm-0.612 2.6383h-3.7697c-0.28403 0-0.51429-0.23025-0.51429-0.51429s0.23025-0.51429 0.51429-0.51429c0.28403 0 0.51429-0.23025 0.51429-0.51429-0.0085729-0.75817 0.53502-1.4102 1.2824-1.5382 0.74734-0.12797 1.4769 0.30605 1.7211 1.0239 0.059899 0.18007 0.2141 0.31252 0.40114 0.34457 0.41573 0.068876 0.71794 0.4324 0.70971 0.85371 0 0.22778-0.090486 0.44624-0.25155 0.6073-0.16107 0.16107-0.37952 0.25155-0.6073 0.25155zm-0.16971 2.0571c-0.28403 0-0.51429 0.23025-0.51429 0.51429v1.5429c0 0.28403-0.23025 0.51429-0.51429 0.51429h-1.1623c-0.20117-0.51513-0.6187-0.91573-1.1417-1.0954-0.47827-1.015-1.5594-1.6027-2.6713-1.4521s-1.9977 1.0047-2.1887 2.1103c-0.71941 0.23645-1.1609 0.96007-1.042 1.708 0.11889 0.74788 0.76299 1.2989 1.5203 1.3006h3.7697c0.90864 0 1.6876-0.64911 1.8514-1.5429h1.0646c0.8521 0 1.5429-0.69076 1.5429-1.5429v-1.5429c0-0.28403-0.23025-0.51429-0.51429-0.51429zm-3.9446 4.1143h-3.7697c-0.28403 0-0.51429-0.23025-0.51429-0.51429 0-0.28403 0.23025-0.51429 0.51429-0.51429 0.28403 0 0.51429-0.23025 0.51429-0.51429-0.0085729-0.75817 0.53502-1.4102 1.2824-1.5382 0.74734-0.12797 1.4769 0.30605 1.7211 1.0239 0.059899 0.18007 0.2141 0.31252 0.40114 0.34457 0.41573 0.068876 0.71794 0.4324 0.70971 0.85371 0 0.22778-0.090486 0.44624-0.25155 0.6073-0.16107 0.16107-0.37952 0.25155-0.6073 0.25155z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#1DDCC0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.11 5.3967l-3.4097 3.4177-1.3114-1.3114c-0.19424-0.22682-0.49923-0.32562-0.78957-0.25578s-0.51704 0.29653-0.58688 0.58688c-0.069841 0.29034 0.028958 0.59533 0.25578 0.78957l1.8678 1.8757c0.14999 0.14878 0.35305 0.23172 0.56431 0.23049 0.20851-8.779e-4 0.40832-0.083658 0.55636-0.23049l3.974-3.974c0.15047-0.14924 0.2351-0.35239 0.2351-0.56431s-0.084635-0.41507-0.2351-0.56431c-0.31-0.30816-0.81067-0.30816-1.1207 0zm-2.1619-5.3967c-4.3896-5.2945e-16 -7.9481 3.5585-7.9481 7.9481-3.5296e-16 4.3896 3.5585 7.9481 7.9481 7.9481 4.3896 0 7.9481-3.5585 7.9481-7.9481 0-2.108-0.83738-4.1296-2.3279-5.6201s-3.5122-2.3279-5.6201-2.3279zm0 14.306c-3.5117 0-6.3584-2.8468-6.3584-6.3584 0-3.5117 2.8468-6.3584 6.3584-6.3584 3.5117 0 6.3584 2.8468 6.3584 6.3584 0 1.6864-0.66991 3.3037-1.8623 4.4961s-2.8097 1.8623-4.4961 1.8623z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.162cbc70e7805278410bb0b8ffed720d.svg";
export { ForwardRef as ReactComponent };